module.exports = __webpack_public_path__ + "static/img/ps_newGift.0a9b3a67.png";